import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const useFetchUserOptions = (withOptions = false) => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/users/getAllUser`
        );
        if (withOptions) {
          const userOptions = res.data.data.map((user) => ({
            value: user._id,
            label: user.fullName,
          }));
          setUsers(userOptions);
        } else {
          setUsers(res.data.data);
        }
      } catch (error) {
        toast.error("Failed to load users", { autoClose: 1000 });
      }
    };

    fetchData();
  }, []);

  return users;
};

export default useFetchUserOptions;
